<script>
  export default {
    name: 'IconClose',
    props: {
      color: {
        type: String,
        default: '#ffffff'
      }
    },
    computed: {
      styles() {
        return {
          fill: this.color
        }
      }
    }
  }
</script>

<template lang="pug">
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" :style="styles">
  <path fill-rule="evenodd" d="M1.283.576a.5.5 0 01.707 0L8 6.586l6.01-6.01a.5.5 0 01.708 0l.707.707a.5.5 0 010 .707L9.415 8l6.01 6.01a.5.5 0 010 .708l-.707.707a.5.5 0 01-.707 0L8 9.414l-6.01 6.01a.5.5 0 01-.707 0l-.707-.706a.5.5 0 010-.707l6.01-6.012-6.01-6.01a.5.5 0 010-.706l.707-.707z"/>
</svg>
</template>

<style lang="scss" scope>
svg {
  display: block;
}
</style>
